import { createMuiTheme } from '@material-ui/core/styles'
import {
    blue,
    red,
    green,
    blueGrey,
    grey,
} from '@material-ui/core/colors'

// declare module "@material-ui/core/styles/createPalette" {
//     interface Palette {
//         complete: Partial<Color>
//         incomplete: Partial<Color>
//         success: Partial<Color>
//         textGray:Partial<Color>
//         lightBlue: Partial<Color>
//         teal: Partial<Color>
//         cyan: Partial<Color>
//         gray: Partial<Color>
//         orange: Partial<Color>
//         indigo: Partial<Color>
//         amber: Partial<Color>
//         deepOrange: Partial<Color>
//         lightGreen: Partial<Color>
//         purple: Partial<Color>
//         deepPurple: Partial<Color>
//         red: Partial<Color>
//     }

//     interface PaletteOptions {
//         complete: SimplePaletteColorOptions | Partial<Color>
//         incomplete: SimplePaletteColorOptions | Partial<Color>
//         success: SimplePaletteColorOptions | Partial<Color>
//         textGray: SimplePaletteColorOptions | Partial<Color>
//         lightBlue: SimplePaletteColorOptions | Partial<Color>
//         teal: SimplePaletteColorOptions | Partial<Color>
//         cyan: SimplePaletteColorOptions | Partial<Color>
//         gray: SimplePaletteColorOptions | Partial<Color>
//         orange: SimplePaletteColorOptions | Partial<Color>
//         indigo: SimplePaletteColorOptions | Partial<Color>
//         amber: SimplePaletteColorOptions | Partial<Color>
//         deepOrange: SimplePaletteColorOptions | Partial<Color>
//         lightGreen: SimplePaletteColorOptions | Partial<Color>
//         purple: SimplePaletteColorOptions | Partial<Color>
//         deepPurple: SimplePaletteColorOptions | Partial<Color>
//         red: SimplePaletteColorOptions | Partial<Color>
//     }
// }

export default createMuiTheme({
    palette: {
        primary: blue,
        secondary: grey,
        error: red,
        success: green,
        // Used by `getContrastText()` to maximize the contrast between the background and
        // the text.
        contrastThreshold: 3,
        // Used to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset: 0.2,
        textGray: blueGrey,
    },
    overrides: {
        MUIDataTableBodyCell: {
            root: {
                whiteSpace: 'pre-wrap',
            },
        },
    },
})
